<template>
	<div class="userList column-me">
		<div class="card-view column-me">
			<div class="card-title">督学人员列表</div>
			<div class="row-me row-center">
				<div class="width300 demo-input-size">
					<el-input placeholder="手机号/姓名" style="width: 100%;" v-model="keyword" :prefix-icon="Search"></el-input>
				</div>
				<el-form-item label="账户状态"  class="margin-left30 margin-top20 width200">
					<el-select v-model="isStatus" placeholder="账户状态">
						<el-option
							v-for="item in statusSearch" 
							:key="item.value"
							:label="item.label"
							:value="item.value">
						</el-option>
					</el-select>
				</el-form-item>
				<el-button class="margin-left20" type="primary" size="mini " @click="clickSearch" >搜索</el-button>
				<el-button size="mini " @click="clickClear" >重置</el-button>
				<el-button type="danger" size="mini " @click="clickAdd" >新增</el-button>
			</div>
			<div class="column-me flex1 overflow-auto">
				<div class="flex1 overflow-auto">
					<el-table :data="tableData" border v-loading="loading" stripe="true" size="medium" style="width: 100%" height="100%">
						<el-table-column prop="type" label="账户类型" align="center" show-overflow-tooltip>
							<template #default="scope">
								<el-tag v-if="scope.row.type == 1" effect="dark" type="danger">管理员</el-tag>
								<el-tag v-if="scope.row.type == 2" effect="dark">督学</el-tag>
							</template>
						</el-table-column>
						<el-table-column prop="real_name" label="姓名" align="center" show-overflow-tooltip></el-table-column>
						<el-table-column prop="phone" label="手机号码" align="center" show-overflow-tooltip></el-table-column>
						<el-table-column prop="studentNum" label="学员数量" align="center" show-overflow-tooltip></el-table-column>
						<el-table-column prop="last_time" label="最后登陆时间" align="center" show-overflow-tooltip></el-table-column>
						<el-table-column label="账户状态" align="center" show-overflow-tooltip>
							<template #default="scope">
								{{ scope.row.status == 1 ? '正常' : '禁用' }}
							</template>
						</el-table-column>
						<el-table-column label="操作" align="center" width="320" show-overflow-tooltip fixed="right">
							<template #default="scope">
								<div class="row-me center-all" >
									<el-button type="primary" size="small " @click="studentBind(scope.row)" >学员绑定</el-button>
									<el-button type="success" plain size="small " @click="pwEdit(scope.row)" >重置密码</el-button>
									<el-button size="small " @click="clickEdit(scope.row)" >修改</el-button>
									<el-button type="danger" size="small " @click="clickDel(scope.row)" >删除</el-button>
								</div>
							</template>
						</el-table-column>
					</el-table>
				</div>
				<div class="margin-top20">
					<el-pagination @current-change="handleCurrentChange" background :current-page.sync="pageNo"
                         layout="total, prev, pager, next, jumper" :total="total">
					</el-pagination>
				</div>
			</div>
		</div>
	</div>
	<!-- 督学信息修改界面 -->
	<el-dialog title="督学信息修改" v-model="adminInfo" width="950px" top="10vh" :destroy-on-close="true">
	    <div class="padding-left80">
	        <div class="row-me row-center margin-top20">
				<div class="left-title"><span class="red-star">*</span>姓名：</div>
				<div class="width500">
					<el-input placeholder="请输入" style="width: 100%;" clearable v-model="editInfo.real_name"></el-input>
				</div>
	        </div>
			<div class="row-me row-center margin-top20">
				<div class="left-title"><span class="red-star">*</span>账户状态：</div>
				<div class="width500">
					<el-select v-model="editInfo.status" placeholder="账户状态">
						<el-option 
							v-for="item in statusOption" 
							:key="item.value"
							:label="item.label"
							:value="item.value">
						</el-option>
					</el-select>
				</div>
			</div>
	        <div class="row-me flex-end1 margin-top50">
				<el-button @click="adminInfo=false">取消</el-button>
				<el-button type="primary" @click="clickSave">确定</el-button>
	        </div>
	    </div>
	</el-dialog>
	<!-- 督学信息添加界面 -->
	<el-dialog title="督学信息添加" v-model="adminInfoAdd" width="950px" top="10vh" :destroy-on-close="true">
	    <div class="padding-left80">
	        <div class="row-me row-center margin-top20">
				<div class="left-title"><span class="red-star">*</span>姓名：</div>
				<div class="width500">
					<el-input placeholder="请输入" style="width: 100%;" clearable v-model="addInfo.real_name"></el-input>
				</div>
			</div>
			<div class="row-me row-center margin-top20">
				<div class="left-title"><span class="red-star">*</span>手机号码：</div>
				<div class="width500">
					<el-input placeholder="请输入" style="width: 100%;" clearable v-model="addInfo.phone"></el-input>
				</div>
			</div>
			<div class="row-me row-center margin-top20">
				<div class="left-title"><span class="red-star">*</span>登陆密码：</div>
				<div class="width500">
					<el-input placeholder="请输入" style="width: 100%;" clearable v-model="addInfo.pwd"></el-input>
				</div>
			</div>
			<div class="row-me row-center margin-top20">
				<div class="left-title"><span class="red-star">*</span>重复密码：</div>
				<div class="width500">
					<el-input placeholder="请输入" style="width: 100%;" clearable v-model="addInfo.pwd_repeat"></el-input>
				</div>
	        </div>
	        <div class="row-me flex-end1 margin-top50">
				<el-button @click="adminInfoAdd=false">取消</el-button>
				<el-button type="primary" @click="addClickSave">确定</el-button>
	        </div>
	    </div>
	</el-dialog>
	<!-- 督学学员绑定界面 -->
	<el-dialog title="督学&学员信息绑定" v-model="studentBindBox" width="1500px" top="10vh" :destroy-on-close="true">
		<div class="row-me row-center">
			<div class="width300 demo-input-size">
				<el-input placeholder="手机号/姓名/昵称" style="width: 100%;" v-model="stuKeyword" :prefix-icon="Search"></el-input>
			</div>
			<el-form-item label="年级"  class="margin-left30 margin-top20 width200">
				<el-select v-model="stuGrade_id" placeholder="年级选择">
					<el-option
						v-for="item in greadoption" 
						:key="item.value"
						:label="item.label"
						:value="item.value">
					</el-option>
				</el-select>
			</el-form-item>
			<el-form-item label="地区"  class="margin-left30 margin-top20 width400">
				<el-cascader
					style="width: 350px;"
				    v-model="area_id_arr"
				    :options="regionOption"
					:props="{ checkStrictly: true }"
				    @change="studentAreaChange"></el-cascader>
			</el-form-item>
			<el-button class="margin-left20" type="primary" size="mini " @click="studentBindSearch" >搜索</el-button>
			<el-button size="mini " @click="studentBindClear" >重置</el-button>
		</div>
		<div class="flex1 overflow-auto height400">
			<el-table 
				:data="studentData"
				ref="studentListinfoTable" 
				@select="studentListinfoSelect"
				@select-all="studentListinfoSelectAll"
				v-loading="loading"
				reserve-selection
				:row-key="studentListinfoGetRowKey"
				stripe="true" 
				size="medium" 
				style="width: 100%" 
				height="100%">
						<el-table-column type="selection" width="55"></el-table-column>
						<el-table-column prop="getTcAgentUser" label="代理商" width="300" align="center" show-overflow-tooltip>
							<template #default="scope">
								<div class="startTimeBox" v-if="scope.row.getTcAgentUser">代理：{{scope.row.getTcAgentUser.lecturer_name}}</div>
								<div class="startTimeBox" v-if="scope.row.getTcAgentUser">联系人：{{scope.row.getTcAgentUser.username}}</div>
								<div class="startTimeBox" v-if="scope.row.getTcAgentUser">地区：{{scope.row.getTcAgentUser.region}}</div>
							</template>
						</el-table-column>
						<el-table-column prop="getTcAdminUser" label="督学" width="200" align="center" show-overflow-tooltip>
							<template #default="scope">
								<div class="startTimeBox" v-if="scope.row.getTcAdminUser">督学：{{scope.row.getTcAdminUser.real_name}}</div>
								<div class="startTimeBox" v-if="scope.row.getTcAdminUser">电话：{{scope.row.getTcAdminUser.phone}}</div>
							</template>
						</el-table-column>
						<el-table-column prop="phone" label="手机号码" width="150" align="center" show-overflow-tooltip></el-table-column>
						<el-table-column prop="nickname" label="昵称" width="150" align="center" show-overflow-tooltip></el-table-column>
						<el-table-column prop="name" label="姓名" width="150" align="center" show-overflow-tooltip></el-table-column>
						<el-table-column prop="ageText" label="年龄" width="80" align="center" show-overflow-tooltip>
							<template #default="scope">
								{{scope.row.ageText}}岁
							</template>
						</el-table-column>
						<el-table-column prop="grade_text" label="年级" width="80" align="center" show-overflow-tooltip></el-table-column>
						<el-table-column prop="area_text" label="地区" align="center" show-overflow-tooltip></el-table-column>						
			</el-table>
		</div>
		<div class="margin-top20">
			<el-pagination @current-change="handleStudentChange" background :current-page.sync="stuPageNo"
                 layout="total, prev, pager, next, jumper" :total="stuTotal">
			</el-pagination>
		</div>
		<div class="row-me flex-end1 margin-top50">
			<el-button @click="studentBindClosed">取消</el-button>
			<el-button type="primary" @click="studentBindSave">确定</el-button>
		</div>
	</el-dialog>
</template>
<script>
import {Plus,Search} from "@element-plus/icons";
import { regionOption } from '../../assets/js/citys.js';
import { onBeforeUnmount, ref, shallowRef, onMounted } from 'vue'
export default {
  components: {Plus,Search,regionOption},
  data() {
    return {
		keyword: '',
		pageNo: 1,
		total: 0,
		loading:false,
		tableData: [],
		isStatus:'',
		editInfo:{
			id: '',
			real_name: '',
			phone: '',
			last_time: '',
			add_time: '',
			status: '',
		},
		addInfo:{
			id: '',
			type:2,
			real_name: '',
			phone: '',
			last_time: '',
			add_time: '',
		},
		statusOption:[{
			value: 1,
			label: '正常',
		},{
			value: 0,
			label: '禁用',
		}],
		statusSearch:[{
			value: 1,
			label: '正常',
		},{
			value: 0,
			label: '禁用',
		}],
		adminInfo:false,
		adminInfoAdd:false,
		//学员绑定
		regionOption:null,
		greadoption:[
			{
				value:1,
				label:'高中'
			},{
				value:2,
				label:'初中'
			}
		],
		studentBindBox:false,
		area_id_arr:[],
		studentData:[],
		studentListInfoData:[],				//学员选中后的数据
		studentListInfoSelectData:[], 		//弹窗学员选择table数据
		stuKeyword:'',
		stuGrade_id:'',
		stuArea_id:'',
		stuPageNo:1,
		stuTotal:0,
		postData:{
			admin_id:0,
			studentIdArr:[]
		}
		
		
		
		
    }
  },
  // 侦听器
  watch: {},
  // 计算属性
  computed: {
    Search() {
      return Search
    }
  },
  // html加载完成之前
  created() {
	  this.regionOption = regionOption;
    this.clickSearch()
  },
  // html加载完成后执行。
  mounted() {

  },
  // 事件方法执行
  methods: {
    clickSearch() {
      this.pageNo = 1
      this.getData()
    },
    clickClear() {
      this.keywords = ''
      this.isStatus = ''
      this.clickSearch()
    },
    
    //table信息修改获取
    clickEdit(item) {
		this.$post('/admin/adminInfo', {
		  id: item.id
		}).then((res) => {
		  if (res) {
		    this.editInfo = res.data;
		    this.adminInfo = true;
		  }
		}).catch((error) => {
		  console.log(error)
		})
    },
	//table信息修改保存
	clickSave(){
		this.$post('/admin/adminInfoAdd', {
			id:this.editInfo.id,
			real_name:this.editInfo.real_name,
			status:this.editInfo.status
			
		}).then((res) => {
			if (res) {
				this.getData();
				this.adminInfo = false;
				this.$message.success('修改成功');
			}
		}).catch((error) => {
			console.log(error)
		})
	},
	clickAdd(){
		this.adminInfoAdd = true;
	},
	//列表分页
	handleCurrentChange(pageNo) {
	    this.pageNo = pageNo
	    this.getData()
	},
	//新增信息保存
	addClickSave(){
		this.$post('/admin/adminInfoAdd', {
			real_name:this.addInfo.real_name,
			phone:this.addInfo.phone,
			type:2,
			pwd:this.addInfo.pwd,
			pwd_repeat:this.addInfo.pwd_repeat
		}).then((res) => {
			if (res) {
				this.getData();
				this.adminInfoAdd = false;
				this.$message.success('添加成功')
			}
		}).catch((error) => {
			console.log(error)
		})
	},
	//删除
	clickDel(item) {
		this.$confirm("您确定删除吗？删除后无法恢复！", "温馨提示", {
		    confirmButtonText: "确定",
		    cancelButtonText: "取消",
		    type: "warning",
		}).then(() => {
		    this.$post('/admin/adminInfoDel', {
		        id: item.id
		    }).then((res) => {
		        if (res) {
		            this.$message.success('删除成功')
		            this.getData()
		        }
		    }).catch((error) => {
		        console.log(error)
		    })
		}).catch((error) => {
				console.log(error)
		});	
	},
	//密码重置接口
	pwEdit(item){
		this.$confirm("确定重置密码？", "温馨提示", {
		    confirmButtonText: "确定",
		    cancelButtonText: "取消",
		    type: "warning",
		}).then(() => {
		    this.$post('/admin/adminResetPwd', {
		        id: item.id
		    }).then((res) => {
		        if (res) {
		            this.$confirm("重置成功，新密码【1234567】？", "温馨提示", {
		            	confirmButtonText: "确定",
		            	cancelButtonText: "取消",
		            	type: "warning",
					})
		        }
		    }).catch((error) => {
		        console.log(error)
		    })
		}).catch((error) => {
				console.log(error)
		});	
	},
    //table获取数据
    getData() {
		this.loading = true;
		this.$post('/admin/adminInfoList', {
			keyword: this.keyword,
			type:2,
			status: this.isStatus,
			page: this.pageNo
		}).then((res) => {
			if (res) {
				this.total = res.data.all_info_num
				this.tableData = res.data.listInfo
				this.loading = false;
			}
		}).catch((error) => {
			console.log(error)
		})
    },
	//======================================学员绑定==========================================
	//学员绑定弹窗打开
	studentBind(obj){
		this.postData.admin_id = obj.id;
		this.studentBindBox = true;
		this.getBindStudents();
		this.getStudentList();
	},
	studentBindClosed(){
		this.studentBindBox = false;
		this.studentData = [],
		this.studentListInfoData = [],				//学员选中后的数据
		this.studentListInfoSelectData = [], 		//弹窗学员选择table数据
		this.stuKeyword = '',
		this.stuGrade_id = '',
		this.stuArea_id = '',
		this.stuPageNo = 1,
		this.stuTotal = 0,
		this.postData = {
			admin_id:0,
			studentIdArr:[]
		}
	},
	//学员绑定弹窗检索
	studentBindSearch() {
	  this.stuPageNo = 1
	  this.getStudentList()
	},
	studentBindClear(){
		this.stuKeyword = '';
		this.stuGrade_id = '';
		this.stuArea_id = '';
		this.stuPageNo = 1;
		this.stuTotal = 0;
		this.getStudentList();
	},
	//地区选择
	studentAreaChange(value){
		this.area_id_arr = value;
		if(this.area_id_arr.length == 1){
			this.stuArea_id = this.area_id_arr[0]; 
		}else if(this.area_id_arr.length == 2){
			this.stuArea_id = this.area_id_arr[1]; 
		}else if(this.area_id_arr.length == 3){
			this.stuArea_id = this.area_id_arr[2]; 
		}
		console.log(this.area_id);
	},
	//学员列表信息获取
	getStudentList(){
		this.loading = true;
		this.$post('/admin/studentList', {
			keyword: this.stuKeyword,
			grade_id:this.stuGrade_id,
			area_id:this.stuArea_id,
			page: this.stuPageNo
		}).then((res) => {
			if (res) {
				//console.log(res.data);
				this.stuTotal = res.data.all_info_num
				this.studentData = res.data.listInfo
				this.loading = false;
				this.$nextTick(() => {
					this.$refs.studentListinfoTable.clearSelection();// 清除当前选择状态
					//console.log(this.studentListInfoSelectData);
				    if (this.studentListInfoSelectData) { // 如果之前有选中项，重新设置选择状态
				        this.studentListInfoSelectData.forEach(row => {
							console.log(row);
				            this.$refs.studentListinfoTable.toggleRowSelection(row, true); // 重新设置选择状态为 true
				        });
				    }
				});		
			}
		}).catch((error) => {
			console.log(error)
		})
	},
	//列表分页
	handleStudentChange(pageNo) {
	    this.stuPageNo = pageNo
	    this.getStudentList()
	},
	//学员选择赋值
	studentListinfoSelect(selection, row){
		this.studentListInfoData = selection;
	},
	studentListinfoSelectAll(selection){
		this.studentListInfoData = selection;
	},
	studentListinfoGetRowKey(row){
		return row.id;
	},
	//选中的学员数据提交
	studentBindSave(){
		//console.log(this.postData);
		if(this.studentListInfoData.length == 0){
			this.$message.error('还未选择学员')
			return;
		}
		for(let i = 0; i < this.studentListInfoData.length; i++){
			this.postData.studentIdArr.push(Number(this.studentListInfoData[i].id));
		}
		this.$post('/admin/studentBindSupervisor', this.postData).then((res) => {
			if (res) {
				this.studentBindClosed();
				this.clickSearch();
			}
		}).catch((error) => {
			console.log(error)
		})
		console.log(this.postData);
	},
	getBindStudents(){
		this.$post('/admin/studentList', {
			admin_id:this.postData.admin_id,
			page: this.stuPageNo
		}).then((res) => {
			if (res) {
				console.log(res.data);
				//this.stuTotal = res.data.all_info_num
				this.studentListInfoSelectData = res.data.listInfo
				
						
				//this.loading = false;
			}
		}).catch((error) => {
			console.log(error)
		})
	}
  },
}
</script>

<style lang="scss" scoped>
.userList {
  height: 100%;

  .img-header {
    width: 60px;
    height: 60px;
    border-radius: 50%;
  }
  
}
.avatarBox{
  	width: 40px;
  	height: 40px;
  	border-radius: 20px;
  	overflow: hidden;
  }
.startTimeBox{
		float: left;
		width: 100%;
		height: 20px;
		text-align: left;
		line-height: 20px;
		font-size: 14px;
		color: #555555;
		// background-color: aquamarine;
	}
</style>
